import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { ResultModule } from '../result/result.module';
import { TypeRangeComponent } from '../shared/components/type-range/type-range.component';
import { SimulationArchitectureModule } from './simulation-architecture/simulation-architecture.module';
import { SimulationAreaFormComponent } from './simulation-area-form/simulation-area-form.component';
import { SimulationAreaResultComponent } from './simulation-area-result/simulation-area-result.component';
import { SimulationAttenuationComponent } from './simulation-attenuation/simulation-attenuation.component';
import { SimulationCollectiveClassificationComponent } from './simulation-collective-classification/simulation-collective-classification.component';
import { SimulationDebugParamsComponent } from './simulation-debug-params/simulation-debug-params.component';
import { CoverageMenuComponent, SimulationCoverageAreaComponent } from './simulation-detail/simulation-coverage-area/simulation-coverage-area.component';
import { SimulationDetailComponent } from './simulation-detail/simulation-detail.component';
import { SimulationFormComponent } from './simulation-form/simulation-form.component';
import { SimulationHeaderComponent } from './simulation-header/simulation-header.component';
import { SimulationListComponent } from './simulation-list/simulation-list.component';
import { SimulationResultComponent } from './simulation-result/simulation-result.component';
import { SimulationStatusComponent } from './simulation-status/simulation-status.component';
import { BalancedUnbalancedToggleComponent } from './simulation-topology/balanced-unbalanced-toggle/balanced-unbalanced-toggle.component';
import { DiagramGroupComponent } from './simulation-topology/diagram-group/diagram-group.component';
import { DiagramHorizontalComponent } from './simulation-topology/diagram-horizontal/diagram-horizontal.component';
import { DiagramComponent } from './simulation-topology/diagram/diagram.component';
import { FiberConnectionComponent } from './simulation-topology/fiber-connection/fiber-connection.component';
import { HorizontalBalancedFormComponent } from './simulation-topology/horizontal-balanced-form/horizontal-balanced-form.component';
import { HorizontalCollectiveUnitsByTypeComponent } from './simulation-topology/horizontal-collective-units-by-type/horizontal-collective-units-by-type.component';
import { HorizontalUnbalancedFormComponent } from './simulation-topology/horizontal-unbalanced-form/horizontal-unbalanced-form.component';
import { SimulationTopologyComponent } from './simulation-topology/simulation-topology.component';
import { VerticalBalancedFormComponent } from './simulation-topology/vertical-balanced-form/vertical-balanced-form.component';
import { VerticalUnbalancedFormComponent } from './simulation-topology/vertical-unbalanced-form/vertical-unbalanced-form.component';
import { VerticalUnitsByTypeComponent } from './simulation-topology/vertical-units-by-type/vertical-units-by-type.component';
import { SimulationValidationComponent } from './simulation-validation/simulation-validation.component';

@NgModule({
  declarations: [
    BalancedUnbalancedToggleComponent,
    DiagramComponent,
    DiagramGroupComponent,
    FiberConnectionComponent,
    HorizontalBalancedFormComponent,
    HorizontalUnbalancedFormComponent,
    HorizontalCollectiveUnitsByTypeComponent,
    SimulationAreaFormComponent,
    SimulationAreaResultComponent,
    SimulationAttenuationComponent,
    SimulationCoverageAreaComponent,
    SimulationDetailComponent,
    SimulationFormComponent,
    SimulationHeaderComponent,
    SimulationListComponent,
    SimulationStatusComponent,
    SimulationResultComponent,
    SimulationValidationComponent,
    SimulationTopologyComponent,
    TypeRangeComponent,
    DiagramComponent,
    DiagramHorizontalComponent,
    DiagramGroupComponent,
    VerticalBalancedFormComponent,
    VerticalUnitsByTypeComponent,
    VerticalUnbalancedFormComponent,
    SimulationDebugParamsComponent,
    CoverageMenuComponent,
    SimulationCollectiveClassificationComponent
  ],
  exports: [
    SimulationListComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ResultModule,
    SimulationArchitectureModule
  ]
})
export class SimulationModule { }
